import { device } from '@/styles/common';
import { faLinkedin, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { AnimatedSpacerContainer, CenterFoldContainer, TitleText } from '../general/CenterFold';
import { style } from './style';

type Props = {};

function EthereumWithdraw({}: Props) {
  return <UseMevETH />;
}

function UseMevETH() {
  return (
    <CenterFoldContainer>
      <TitleText>How mevETH Compares</TitleText>
      <AnimatedSpacerContainer>
        <>
          <table>
            <thead>
              <tr>
                <th style={{ padding: '10px' }}>&nbsp;</th>
                <th style={{ padding: '10px' }}>mevETH</th>
                <th style={{ padding: '10px' }}>Lido</th>
                <th style={{ padding: '10px' }}>RocketPool</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ padding: '10px' }}>Open Source</td>
                <td style={{ padding: '10px' }}>✅</td>
                <td style={{ padding: '10px' }}>❌</td>
                <td style={{ padding: '10px' }}>✅</td>
              </tr>
              <tr>
                <td style={{ padding: '10px' }}>MEV Rewards</td>
                <td style={{ padding: '10px' }}>✅</td>
                <td style={{ padding: '10px' }}>✅</td>
                <td style={{ padding: '10px' }}>✅</td>
              </tr>
              <tr>
                <td style={{ padding: '10px' }}>Higher Yields</td>
                <td style={{ padding: '10px' }}>✅</td>
                <td style={{ padding: '10px' }}>✅</td>
                <td style={{ padding: '10px' }}>✅</td>
              </tr>
            </tbody>
          </table>
        </>

        <ExplainerText>{'Compare mevETH with most other popular Staking options'}</ExplainerText>
      </AnimatedSpacerContainer>
    </CenterFoldContainer>
  );
}
const SocialIcons = styled.div`
  font-size: 8px;

  @media ${device.mobileS} {
    font-size: 8px;
  }
`;
const MemberName = styled.p`
  font-weight: bold;
  font-size: 17px;

  @media ${device.mobileS} {
    font-size: 16px;
  }
`;
const TitleName = styled.p`
  @media ${device.mobileS} {
    font-size: 13px;
  }
`;
const LogosRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 24px;
  text-align: center;
`;

const Image = styled.img<{ isActive: boolean }>`
  height: 120px;
  width: 120px;
  margin-bottom: 15px;
  @media ${device.mobileS} {
    height: 100px;
    width: 100px;
  }
  opacity: ${({ isActive }) => (isActive ? 1 : 0.5)};
  &:hover {
    ${({ isActive }) =>
      !isActive &&
      'opacity: ${({ isActive }) => (isActive ? 1 : 0.8)}; cursor: pointer; transform: scale(1.05)'}
  }

  transition: all 0.2s ease-in-out;
`;

const ExplainerText = styled(motion.div)`
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  height: 48px;
  margin-top: 16px;

  @media ${device.mobileS} {
    font-size: 14px;
  }
`;
export default function StakeCenterFold({}: Props) {
  return <EthereumWithdraw />;
}
